import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum, PricePlanId } from '@systemeio/types';
import { useUserPricePlans } from 'modules/digital-product/price-plans/hooks/use-user-price-plans';
import React, { useEffect, useState } from 'react';
import { RadioGroup } from 'shared/components';
import Confirmation from 'shared/components/confirmation-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { PricePlanRemoveTypeEnum } from '../enums/price-plan-remove-type-enum';
import { getPricePlanRemoveTypeData } from '../utils/price-plans-utils';
interface RemovePricePlanConfirmationProps {
  pricePlanId: PricePlanId | null;
  currency: CurrencyEnum;
  onRemove: (removeType: PricePlanRemoveTypeEnum) => Promise<void>;
  afterLeave: () => void;
}
function RemovePricePlanConfirmation(t0) {
  const $ = _c(44);
  const {
    pricePlanId,
    currency,
    onRemove,
    afterLeave
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = getPricePlanRemoveTypeData(t);
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const pricePlanRemoveTypeData = t1;
  const [removeType, setRemoveType] = useState(pricePlanRemoveTypeData[0].id);
  const [opened, setOpened] = useState(false);
  const {
    userPricePlans
  } = useUserPricePlans(currency);
  let t2;
  let t3;
  if ($[2] !== pricePlanId) {
    t2 = () => {
      setOpened(!!pricePlanId);
    };
    t3 = [pricePlanId];
    $[2] = pricePlanId;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let T0;
  let T1;
  let t10;
  let t11;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] !== afterLeave || $[6] !== onRemove || $[7] !== opened || $[8] !== pricePlanId || $[9] !== removeType || $[10] !== t || $[11] !== userPricePlans) {
    const pricePlan_0 = userPricePlans?.find(pricePlan => pricePlan.id === pricePlanId);
    T1 = Confirmation;
    t6 = "error";
    t7 = opened;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = () => {
        setOpened(false);
      };
      $[22] = t8;
    } else {
      t8 = $[22];
    }
    t9 = afterLeave;
    if ($[23] !== onRemove || $[24] !== removeType) {
      t10 = () => onRemove(removeType);
      $[23] = onRemove;
      $[24] = removeType;
      $[25] = t10;
    } else {
      t10 = $[25];
    }
    t11 = t("dashboard.funnel.configuration.common.price_plan.remove_confirmation", {
      pricePlanName: pricePlan_0?.innerName
    });
    t5 = "flex justify-start";
    T0 = RadioGroup;
    t4 = t("dashboard.funnel.configuration.common.price_plan.remove_confirmation", {
      pricePlanName: pricePlan_0?.innerName
    });
    $[5] = afterLeave;
    $[6] = onRemove;
    $[7] = opened;
    $[8] = pricePlanId;
    $[9] = removeType;
    $[10] = t;
    $[11] = userPricePlans;
    $[12] = T0;
    $[13] = T1;
    $[14] = t10;
    $[15] = t11;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    T0 = $[12];
    T1 = $[13];
    t10 = $[14];
    t11 = $[15];
    t4 = $[16];
    t5 = $[17];
    t6 = $[18];
    t7 = $[19];
    t8 = $[20];
    t9 = $[21];
  }
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = data => setRemoveType(data);
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== T0 || $[28] !== pricePlanRemoveTypeData || $[29] !== removeType || $[30] !== t4) {
    t13 = <T0 ariaLabel={t4} orientation="vertical" options={pricePlanRemoveTypeData} selected={removeType} onChange={t12} />;
    $[27] = T0;
    $[28] = pricePlanRemoveTypeData;
    $[29] = removeType;
    $[30] = t4;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t13 || $[33] !== t5) {
    t14 = <div className={t5}>{t13}</div>;
    $[32] = t13;
    $[33] = t5;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== T1 || $[36] !== t10 || $[37] !== t11 || $[38] !== t14 || $[39] !== t6 || $[40] !== t7 || $[41] !== t8 || $[42] !== t9) {
    t15 = <T1 status={t6} opened={t7} onClose={t8} afterLeave={t9} onConfirm={t10} confirmationText={t11} confirmationContent={t14} />;
    $[35] = T1;
    $[36] = t10;
    $[37] = t11;
    $[38] = t14;
    $[39] = t6;
    $[40] = t7;
    $[41] = t8;
    $[42] = t9;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  return t15;
}
export default RemovePricePlanConfirmation;